import React, {useState} from "react";
import classNames from "classnames";
import {Checkbox, CircularProgress, Fab, withStyles} from "@material-ui/core";
import Scroll from "../../../../../components/InfiniteScroll/Scroll";
import InputMaskCurrency from "../../../../../components/Input/InputMaskCurrency";
import ConfiguracoesIcon from "../../../../../components/Icon/Configuracoes";
import ModalConfigVigencia from "../../../../../components/Modal/ModalConfigVigencia/ModalConfigVigencia";
import moment from "moment";

const ConvenioList = ({
  classes,
  listaModal,
  handleChangeCheckbox,
  handleChange,
  loadMore,
  lastScroll,
  loadingModal,
  procedimentoSelected,
  loadConvenios,
  clearListConvenio,
  handleEditar,
}) => {
  const [openModal,setOpenModal]=useState(false)
  const [convenio,setConvenio]=useState(null)

  const getVigencia = (convenio) => {
    const { vigencia } = convenio || {};
    const {dataInicioVigencia,dataFimVigencia}=vigencia || {}

    const dataInicioFormatada= dataInicioVigencia && moment(dataInicioVigencia).format("DD/MM/YYYY")
    const dataFimFormatada= dataFimVigencia && moment(dataFimVigencia).format("DD/MM/YYYY")

     return `${dataInicioFormatada || ""} - ${dataFimFormatada || ''}`;
  }

  const handleClick = (e) => {
    setOpenModal(true)
    const convenio = {
     ...e.convenio,
     procedimentoSelected
    }
    setConvenio(convenio)
  }
  
  const handleClose =()=>{
    setOpenModal(false)
  }

  const findAllDados = () => {
    clearListConvenio()
    loadConvenios()
  }

  return (
    <div className={classes.content}>
      <div className={classes.titles}>
        <div className={classNames(classes.title, classes.motivoVigencia)}>
          <div className={classNames([ procedimentoSelected?.id ? classes.titleValorVigencia : classes.titleSemValorVigencia])}>
            <div className={classes.title}> Selecione o convênio </div>
            <div className={classNames([classes.title, procedimentoSelected?.id ? classes.vigencia : classes.titleSemValorVigencia])}>
              Valor
            </div>
            {procedimentoSelected?.id &&
              <>
                <div className={classNames(classes.title, classes.vigencia)}>
                  Vigência
                </div>
                <div className={classNames(classes.title, classes.acoesVigencia)}>
                  Ações
                </div>
              </>}
          </div>
        </div>
      </div>
      <Scroll
        loadMore={loadMore}
        hasMore={!lastScroll}
        pageStart={0}
        initialLoad={false}
        className={classes.scrollContainerModelos}
      >
        {listaModal.length > 0 &&
          listaModal.map((itemLista, index) => (
            <div className={classes.linha} key={index}>
              <div className={classes.checkboxDescricao}>
                <Checkbox
                  id={`cfg-cvl-chk-sel-${index}`}
                  color={"primary"}
                  onChange={() => handleChangeCheckbox(itemLista, index)}
                  checked={itemLista.convenio?.checked || itemLista.convenios?.checked}
                />
                <div className={classes.convenio}>
                  {itemLista.convenio?.descricao ?? itemLista.convenios.descricao}
                </div>
              </div>
              <div className={classes.columnsMotivoVigencia}>
                <div className={classes.contentValorVigencia}>
                  <InputMaskCurrency
                    id={`cfg-cvl-inp-val-${index}`}
                    name={"valor"}
                    value={itemLista?.valor === 0 ? "" : itemLista?.valor}
                    className={classNames(
                      classes.inputValor,
                      !(itemLista.convenio?.checked ?? itemLista.convenios.checked) && classes.inputValorDesabilitado
                    )}
                    onChange={(e) => handleChange(e, itemLista, index)}
                    disabled={procedimentoSelected?.id}
                  />
                  {procedimentoSelected?.id &&
                    <>
                      <div className={classes.dataVigencia}>
                        {getVigencia(itemLista)}
                      </div>
                      <Fab
                        id={`cfg-cvl-btn-cfg-${index}`}
                        size={"small"}
                        className={classes.config}
                        onClick={() => handleClick(itemLista)}
                      >
                        <ConfiguracoesIcon color={"#868686"} />
                      </Fab>
                    </>
                  } 
                </div>
              </div>
            </div>
          ))}
        {loadingModal && (
          <div className={classes.contentLoading}>
            <CircularProgress />
          </div>
        )}
      </Scroll>
      {openModal &&
        <ModalConfigVigencia
        title={`${convenio.descricao}${procedimentoSelected?.nome ?` - ${procedimentoSelected?.nome}` : ""}`} 
          open={openModal}
          convenio={convenio}
          handleClose={handleClose}
          procedimentoSelected={procedimentoSelected}
          findAllDados={findAllDados}
          handleEditar={handleEditar}
        />}
    </div>
  );
};

const styles = {
  content: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    minHeight: 0,
    overflow: "hidden",
  },
  titles: {
    display: "grid",
    background: "#fff",
    width: "100%",
    flexShrink: 0,
    paddingBottom: "4px",
  },
  title: {
    fontSize: "10px",
    color: "#868686",
    marginRight: '7px',
  },
  motivoVigencia: {
    display: "flex",
  },
  convenio: {
    color: "#868686",
  },
  linha: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "4px",
  },
  inputValor: {
    background: "#F2F2F2",
    padding: "4px 4px 4px 8px",
    width: "90px",
    height: "30px",
    border: "1px solid rgba(220, 220, 220, 0.2)",
    borderRadius: "8px",
  },
  checkboxDescricao: {
    display: "flex",
    "&>span": {
      color: "#868686",
    },
  },
  columnsMotivoVigencia: {
    display: "flex",
    gap: "8px",
  },
  contentLoading: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
  },
  scrollContainerModelos: {
    flex: 1,
    minHeight: 0,
    maxHeight: "unset !important",
    overflowY: "auto !important",
    overflowX: "hidden",
  },
  inputValorDesabilitado: {
    color: "#E5E5E5",
  },
  contentValorVigencia: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  dataVigencia:{
    width: '165px',
    height: '40px',
    borderRadius: '8px',
    background: '#f2f2f2',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textWrap: 'nowrap',
    fontSize: '12px',
    color: '#505050',
    fontWeight: '500'
  },
  titleValorVigencia: {
    display: 'grid',
    gridTemplateColumns: '9fr 2fr 2fr 2.5fr',
    gap: '21px',
    marginLeft: '0px',
    justifyContent: 'center',
    alignItems: 'center',
    justifyItems: 'center',
    width: '100%',

    "& div ": {
      color: '#868686',
      fontSize: '10px',
      marginRight: '7px',
    }
  },
  acoesVigencia:{
    color: '#868686',
    fontSize: '10px',
    marginRight: '7px',
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'flex-end'
  },
  vigencia:{
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center'
  },
  titleSemValorVigencia: {
    width: '100%',
    display: 'grid',
    justifyContent: 'flex-end',
    gridTemplateColumns: '11fr 2fr',
    justifyItems: 'start',
    "& div": {
      color: '#868686',
      fontSize: '10px',
      marginRight: '7px',
    }
  },
  config:{
    cursor: 'pointer',
    height: '14px',
    padding: '0',
    background: '#ffffff',
    border: 'none',
    boxShadow: 'none'
  },
  selectMotivo: {
    width: '100px',
    "&> div": {
      width: "100px",
      "&> div > div": {
        height: "40px",
      },
    },
  },
};

export default withStyles(styles)(ConvenioList);
